import styled from '@emotion/styled';

export const HorizontalRule = styled.hr`
  width: 100%;
  height: 2px;

  background-color: lightgrey;
  border: none;

  margin-bottom: 1.5rem;
`;
